import merge from 'lodash/merge'
import router from '@/router'
import { functions } from '@/firebase'
import { displayMessage } from '@/util'

const initialState = {
  brand: '',
  cancelAtPeriodEnd: false,
  currentPeriodEnd: null,
  last4: null,
  loading: true,
  periodEnd: null,
  status: false,
  trialEnd: null,
}

const actions = {
  async getSubscription({ commit }) {
    commit('setSubscriptionLoading', true)
    const subscription = await functions.getSubscription()
    if (subscription && subscription.data) {
      commit('modifyUserSubscription', subscription.data)
    }
    commit('setSubscriptionLoading', false)
  },
  async addPaymentMethod({ commit }, { token }) {
    const { data } = await functions.addPaymentMethod({
      stripeToken: token.id,
    })

    commit('modifyUserSubscription', data)

    displayMessage('Payment method added successfully!')
    router.push('/settings')
  },
  async subscribeUser({ commit }, { coupon, token = {} }) {
    const { data } = await functions.addSubscription({
      coupon,
      stripePlan: 'premium_monthly',
      stripeToken: token.id,
    })

    commit('modifyUserSubscription', data)

    displayMessage('Subscription successful!')
    router.push('/home')
  },
  async resubscribeUser({ commit }) {
    commit('setSubscriptionLoading', true)
    const { data } = await functions.resubscribe()

    commit('modifyUserSubscription', data)

    displayMessage('Subscription successful!')
    commit('setSubscriptionLoading', false)
  },
  async unsubscribeUser({ commit }) {
    commit('setSubscriptionLoading', true)
    const { data } = await functions.cancelSubscription()

    commit('modifyUserSubscription', data)

    displayMessage('You have been successfully unsubscribed.')
    commit('setSubscriptionLoading', false)
  }
}

export const hasSubscription = status => ['trialing', 'active'].includes(status)

const getters = {
  hasSubscription: state => hasSubscription(state.status),
  subscriptionIsLoading: state => state.loading,
  userSubscription: state => state
}

const mutations = {
  modifyUserCard(state, { brand, last4 }) {
    merge(state.subscription, {
      brand,
      last4,
    })
  },
  modifyUserSubscription(state, {
    brand,
    cancel_at_period_end: cancelAtPeriodEnd,
    current_period_end: currentPeriodEnd,
    discount,
    last4,
    status,
    trial_end: trialEnd
  } = {}) {
    const discountEnd = discount ? discount.end : null
    merge(state, {
      brand,
      cancelAtPeriodEnd,
      currentPeriodEnd,
      discountEnd,
      last4,
      status,
      trialEnd
    })
  },
  resetSubscription(state) {
    state.brand = null
    state.cancelAtPeriodEnd = null
    state.currentPeriodEnd = null
    state.discountEnd = null
    state.last4 = null
    state.status = null
    state.trialEnd = null
  },
  setSubscriptionLoading(state, loading) {
    state.loading = loading
  },
}

export default {
  state: initialState,
  actions,
  getters,
  mutations
}
